import React, { useState } from "react";
import { Flex, Icon, Text } from "@chakra-ui/react";
import { useSession } from "next-auth/react";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";
import {
  Home,
  Edit3,
  XCircle,
  Phone,
  Mail,
  LogIn,
  RefreshCcw,
} from "react-feather";

import ButtonAnimated from "@/components/common/ButtonAnimated";
import { Product } from "@/types/product";

type Props = {
  product: Product;
  onEndClick: () => void;
  onRefreshClick: () => void;
  onMessageClick: () => void;
};

const Buttons = ({
  product,
  onEndClick,
  onRefreshClick,
  onMessageClick,
}: Props): React.ReactElement => {
  const { t } = useTranslation();
  const { data: session, status } = useSession();
  const router = useRouter();
  const [loginToMessage, setLoginToMessage] = useState(false);
  const [showPhone, setShowPhone] = useState(false);
  const isUserProduct =
    session?.user?.id &&
    product?.user?.id &&
    session?.user?.id === product?.user?.id;

  return (
    <Flex align={"center"} justify="center" flexDirection="column">
      {isUserProduct && (
        <>
          <ButtonAnimated
            variant="green"
            text={
              <Flex align={"center"} justifyContent="center">
                <Icon
                  as={product?.endOfferDate ? RefreshCcw : Edit3}
                  w={6}
                  h={6}
                  mr={2}
                />
                <Text>
                  {product?.endOfferDate ? t("refreshProduct") : t("edit")}
                </Text>
              </Flex>
            }
            width={"250px"}
            onClick={() => {
              if (product?.endOfferDate) onRefreshClick();
              else router.push(`/add-product/${product?.id}`);
            }}
          />
          {!product?.endOfferDate && (
            <ButtonAnimated
              text={
                <Flex align={"center"} justifyContent="center">
                  <Icon as={XCircle} w={6} h={6} mr={2} />
                  <Text>{t("finish")}</Text>
                </Flex>
              }
              width={"250px"}
              mt={3}
              onClick={() => onEndClick()}
            />
          )}
        </>
      )}
      {!isUserProduct && !product?.endOfferDate && (
        <>
          <ButtonAnimated
            text={
              <Flex align={"center"} justifyContent="center">
                <Icon as={loginToMessage ? LogIn : Mail} w={6} h={6} mr={2} />
                <Text>
                  {!loginToMessage
                    ? t("product.sendMessage")
                    : t("signin.login")}
                </Text>
              </Flex>
            }
            variant="blue"
            onClick={() =>
              status === "authenticated"
                ? onMessageClick()
                : router.push("/signin")
            }
            onMouseEnter={() => {
              if (status === "unauthenticated") setLoginToMessage(true);
            }}
            onMouseLeave={() => {
              if (status === "unauthenticated") setLoginToMessage(false);
            }}
            width={"280px"}
          />
          {product?.garage?.phone && (
            <ButtonAnimated
              text={
                <Flex align={"center"} justifyContent="center">
                  <Icon as={Phone} w={6} h={6} mr={2} />
                  <Text>
                    {showPhone ? product?.garage?.phone : t("product.call")}
                  </Text>
                </Flex>
              }
              onClick={() => setShowPhone(true)}
              width={"280px"}
              mt={3}
            />
          )}
        </>
      )}
      {!isUserProduct && product?.endOfferDate && (
        <ButtonAnimated
          variant="green"
          text={
            <Flex align={"center"} justifyContent="center">
              <Icon as={Home} w={5} h={5} mr={2} />
              <Text>{t("product.checkOtherGarageProducts")}</Text>
            </Flex>
          }
          width={"80%"}
          onClick={() => router.push(`/g/${product?.garage?.slug}`)}
        />
      )}
    </Flex>
  );
};

export default Buttons;
